module.exports = __webpack_public_path__ + "static/media/coffee-gb.2c253c0d.png";